<template>
    <div class="h-full">
        <ai-grid-edit-core
            ref="notebookGrid"
            :meta="meta"
            :data-source="dataSoure"
            :editing="editing"
            @saveClick="saveData"
        />
    </div>
</template>

<script setup>
import AiGridEditCore from '@/components/ai-grid-edit/ai-grid-edit-core.vue';
import { computed, onMounted, ref, reactive } from 'vue';
import {useRoute} from "vue-router";
//import {useStore} from 'vuex';
import { getNotebook , getArea } from '@/service/counteragent-service';
import { commitDataChanges } from '@/service/meta-service';
import { dxUiNotify } from '@/utils/dx-helper';



//const store = useStore()
const notebookGrid = ref();
//const gridInstance = ref(null);
const dataSoure = ref([]);

const area = ref([]);
const areaComp = computed(() => area.value); // computed(() => store.state.area);

const refreshDicts = async () => {
    const data = await getArea();
    if (data && data.result) {
        area.value = data.data;
    }
};

const refreshData = async () => {
    const data = await getNotebook(route.params.id);
    if (data && data.result) {
        await notebookGrid.value.gridInstance.option('editing.changes', []);
        dataSoure.value = data.data;
    }
};

const saveData = async () => {
    const dataChanges = {
        insertDataArgs: [],
        updateDataArgs: [],
        deleteDataArgs: []
    }
    var pr_success = true;
    //notebookGrid.value.userData.gridChanges.forEach((row) =>
    for (const row of notebookGrid.value.userData.gridChanges)
    {
        if (row.type === 'insert') {
            const rowData = {
                ...notebookGrid.value.gridInstance.option('columns')
                    .map(col => col.dataField)
                    .reduce((obj, key) => ({...obj, [key]: null}), {}), ...row.data
            };
            rowData['greyEminence'] = row.key;
            rowData['kodp'] = route.params.id;
            dataChanges.insertDataArgs.push(rowData);
        } else if (row.type === 'update') {
            notebookGrid.value.gridInstance.byKey(row.key).then((rowData) => {
                dataChanges.updateDataArgs.push(rowData);
            });
        } else if (row.type === 'remove') {
            dataChanges.deleteDataArgs.push(row.key);
        }
        const res = await commitDataChanges(meta.api.save, dataChanges);
        console.log('widget-notebook-core commit ', res);
        const { errors, validationErrors } = await commitDataChanges(meta.api.save, dataChanges);
        if (errors.length > 0 || validationErrors.length > 0) {
            pr_success = false;
        }
    }
    if (pr_success) {
        await refreshData();
        dxUiNotify('Изменения данных прошли успешно', 'success');
    }

}


onMounted(async () => {
    await refreshDicts()
    await refreshData()
});

const route = useRoute()

const meta = reactive ({
    title: 'Записная книжка',
    keyExpr: 'id',
    viewId: 'WidgetPayerNotebookCore',
    focusedRowEnabled: true,
    api: {
        select: 'counteragent./customer/card/widget/notebook/get',
        save: 'counteragent./customer/card/widget/notebook/save'
    },
    columns: [
        {
            dataField: 'id',
            caption: 'ID',
            visible: false,
            allowEditing: false,
            dataType: 'number',
        },
        {
            dataField: 'txt',
            caption: 'Текст записной книжки',
            dataType: 'string',
            allowEditing: true,
        },
        {
            dataField: 'dat',
            caption: 'Дата ввода',
            dataType: 'date',
            allowEditing: false,
        },
        {
            dataField: 'kod_area',
            caption: 'Область применения',
            readOnly: true,
            lookup: {
                dataSource: areaComp,
                displayExpr: 'name',
                valueExpr: 'kod_area'
            }
        },
    ],
});

const editing = {
    enableDeleting: true,
    allowAdding: true,
    allowUpdating: true,
};



</script>

